import { gql } from '@apollo/client';

export const RESOLVE_DATA_FIX_MUTATION = gql`
  mutation ResolveDataFixRequestViaService(
    $input: ResolveDataFixRequestInput!
  ) {
    resolveDataFixRequestViaService(input: $input) {
      id
      status
      targetId
      resolvedAt
    }
  }
`;

export const BLOCK_DATA_FIX_MUTATION = gql`
  mutation BlockDataFixRequest($input: BlockDataFixRequestInput!) {
    blockDataFixRequest(input: $input) {
      id
      status
      reason
    }
  }
`;

export const APPROVE_DATA_FIX_MUTATION = gql`
  mutation ApproveDataFixRequest($input: ApproveDataFixRequestInput!) {
    approveDataFixRequest(input: $input) {
      id
      status
      resolvedAt
    }
  }
`;

export const REJECT_DATA_FIX_MUTATION = gql`
  mutation RejectDataFixRequest($input: RejectDataFixRequestInput!) {
    rejectDataFixRequest(input: $input) {
      id
      status
      reason
    }
  }
`;

export const CREATE_DATA_FIX_MUTATION = gql`
  mutation CreateDataFixRequestViaService($input: CreateDataFixRequestInput!) {
    createDataFixRequestViaService(input: $input) {
      id
      status
      workflow
      sourceId
      targetId
      matchId
      actionType
    }
  }
`;
